const benefits = [
  {
    image: '/images/mulai-investasi/benefit1.png',
    title: 'Mudah Digunakan',
    desc: 'Di design oleh investor khusus untuk investor. Mulai berinvestasi tanpa manual. <br /> Swipe. Order. Done.',
  },
  {
    image: '/images/mulai-investasi/benefit2.png',
    title: 'Keamanan Generasi Terbaru',
    desc: 'Dilengkapi dengan teknologi keamanan yang canggih menggunakan Fingerprint dan Face ID untuk kemudahan dan keamanan Anda.',
  },
  {
    image: '/images/mulai-investasi/benefit3.png',
    title: 'Dana Anda Aman',
    desc: 'Semua dana Anda akan disimpan di rekening terpisah di Rekening Dana Nasabah (RDN) atas nama Anda sendiri sehingga tidak dapat disalahgunakan oleh pihak lain.',
  },
  {
    image: '/images/mulai-investasi/benefit4.png',
    title: 'Personal Customer Support',
    desc: 'Tim support kami selalu siap untuk membantu masalah Anda lewat live chat support kami.',
  },
];

export default benefits;
